<div class="container">
  @if (authService.isBusySig()) {
    <div class="login-active">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else {
    <div class="login-container">
      <div class="login-header">
        <p>Log in to your account</p>
      </div>
      <div class="login-content">
        <button id="btnLogin" type="button" class="cursor" (click)="login()">
          <img src="microsoft-logo.png" alt="Microsoft Logo" />
          <p>Sign in with Microsoft</p>
        </button>
      </div>
    </div>
  }
</div>
